<template>
  <div>
    <es-form :padding="{ padding: '0 1.15rem 1.15rem' }">
      <template #es-form>
        <div class="row removeUnderline">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                File to Upload
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <!-- adding flex classes for help text below file input -->
                  <div
                    class="
                      is-flex
                      flex-direction--column
                      flex-justify--start
                      file
                      has-name
                      is-right
                      is-fullwidth"
                  >
                    <es-file-upload-input
                      :has-error-file="hasErrorFile"
                      input-id="id"
                      input-ref="inputFile"
                      :selected-files="files"
                    />
                    <div v-if="hasErrorFile" class="help is-danger">
                      {{ errorMsgFile }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row removeUnderline">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                <span v-if="!personTypes.length">
                  {{ getFieldLabel(`PER:${personType}:DIRECTMATCH:DISTRICT_CODE`) }}
                </span>
                <span v-else>
                    {{ getFieldLabel(`PER:${personTypes[0].code}:DIRECTMATCH:DISTRICT_CODE`) }}
                </span>
              </label>
            </div>
            <div class="field-body">
              <!-- TODO: Not allow single district user to clear districts. -->
              <es-select
                api="districts"
                :error-msg="errorMsgDistrict"
                :has-error="hasErrorDistrict"
                keyValue="code"
                :pre-selected="districtCodes"
                ref="selDistricts"
                :search="true"
                search-min-length="2"
                :value-tpl-fn="(result) => `${result.location.name} (${result.code})`"
                @update:values="districts = $event"
              />
            </div>
          </div>
        </div>
        <div class="row removeUnderline" v-if='dmPersonTypeMatching'>
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                Person Type
              </label>
            </div>
            <div class="field-body">
              <es-select
                v-on:update:values="personTypes = $event;"
                valueTpl="${name}"
                :error-msg="errorMsgPersonType"
                :has-error="hasErrorPersonType"
                :preSelected=null
                :setValues="sortedPersonTypes"
                keyValue="code"
                ref="selPersonType"
              />
            </div>
          </div>
        </div>
        <div class="row removeUnderline">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                Match Type
              </label>
            </div>
            <div class="field-body">
              <div
                v-if="!enableMatchTypeSelection"
                class="field"
              >
                <div class="control">
                  <div
                    class="select"
                    :class="{'is-danger' : hasErrorMatchType}"
                  >
                    <select
                      disabled
                      style="width: 214.75px"
                    >
                    </select>
                  </div>
                </div>
                <p v-if="hasErrorMatchType" class="help is-danger">
                  {{ errorMsgMatchType }}
                </p>
              </div>
              <template v-else>
                <es-select
                  v-on:update:values="matchTypes = $event;"
                  :preSelected=null
                  :disabled="!personTypes.length && dmPersonTypeMatching"
                  :error-msg="errorMsgMatchType"
                  :has-error="hasErrorMatchType"
                  key-value="programCode"
                  ref="selMatchType"
                  :multi="true"
                  :setValues="filterProgramsByPersonType"
                  :value-tpl-fn="(result) => `${result.program.description}`"
                />
              </template>
            </div>
          </div>
        </div>
      </template>
    </es-form>
    <div
      class="is-flex flex-justify--end flex-align--center"
      style="margin-right: 5.15rem; padding-bottom: 2rem"
    >
      <button
        class="button button-link has-underline"
        @click="reset"
        style="margin-right: 1rem"
        :disabled="loadingMatch"
      >
        Reset
      </button>
      <button
        class="button is-primary"
        @click="checkForm"
        :disabled="loadingMatch"
      >
        {{ properties['BUTTON_LABEL-ASSIGN_EXISTING'] }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
import { mapGetters } from 'vuex';
import EsFileUploadInput from '@/components/EsFileUploadInput.vue';
import EsForm from '@/components/EsForm.vue';
import EsSelect from '@/components/EsSelect.vue';
import FieldLabels from '@/mixins/FieldLabels';
import NotificationManager from '@/mixins/NotificationManager';

export default {
  mixins: [
    FieldLabels,
    NotificationManager,
  ],
  components: {
    EsFileUploadInput,
    EsForm,
    EsSelect,
  },
  props: {
    // value coming from router to help return the match type id for the give matchTypeCode.
    matchTypeCode: {
      type: String,
    },
    dmPersonTypeMatching: {
      type: Boolean,
    },
    personType: {
      type: String,
    },
    sortedPersonTypes: {
      type: Array,
    },
  },
  data() {
    return {
      districtCodes: [], // single district users to pass in distictCode to es-selct
      districts: [], // slected districts
      schoolCodes: [],
      schools: [],
      errorMsgFile: 'No file chosen File to Upload is required.',
      errorMsgDistrict: null,
      errorMsgMatchType: null,
      errorMsgPersonType: null,
      files: [], // selected files: null,
      hasErrorDistrict: null, // problem with selected district
      hasErrorFile: null, // problem with selected file
      hasErrorMatchType: null, // problem with selected match type
      hasErrorPersonType: null,
      loadingMatch: null, // loading variable for loading match
      matchTypes: [], // selected match types
      resetting: null,
      personTypes: [],
      selectedPersonTypes: [],
      programs: [],
    };
  },
  async created() {
    this.checkUserTypes();
    this.loadPrograms();
    this.selectedPersonTypes = JSON.parse(JSON.stringify(this.personTypes));
  },
  watch: {
    // watch required fields
    // when their values change, validate their values
    districts() {
      if (!this.resetting) {
        this.validateDistrict();
      }
    },
    files() {
      if (!this.resetting) {
        this.validateFile();
      }
    },
    // matchTypes() {
    //   if (!this.resetting) {
    //     this.validateMatchType();
    //   }
    // },
    personTypes(newVal) {
      if (!this.resetting) {
        this.validatePersonType();
      }
      if (JSON.stringify(newVal) !== JSON.stringify(this.selectedPersonTypes)) {
        this.$refs.selMatchType.clear();
      }
      this.selectedPersonTypes = JSON.parse(JSON.stringify(newVal));
    },
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    ...mapGetters([
      'isSingleDistrictUser',
      'isSingleSchoolUser',
      'isStateUser',
      'isStateUser',
      'userDistricts',
      'userSchools',
    ]),
    ...mapGetters('lookups', [
      'activeMatchTypes',
      'defaultPersonType',
    ]),
    enableMatchTypeSelection() {
      //  If there is default value in District or School field, or the user selects a specific
      // district or school, enable match types.
      return this.districts.length;
    },
    formDataBody() {
      const formData = new FormData();
      if (this.files.length) {
        formData.append('file', this.files[0]);
      }
      if (this.districts.length) {
        formData.append('districtCode', this.districts[0].code);
      }
      if (this.schools.length) {
        formData.append('schoolCode', this.schools[0].code);
      }
      if (this.matchTypes.length) {
        this.matchTypes.forEach((matchType) => {
          formData.append('programCodes', matchType.programCode);
        });
        formData.append('matchTypeId', this.matchTypeId);
        return formData;
      } return null;
    },
    matchTypeId() {
      return this.activeMatchTypes.find(m => m.code === this.matchTypeCode).id;
    },
    filterProgramsByPersonType() {
      if (this.dmPersonTypeMatching === false) {
        return this.programs;
      }
      const selectedPersonType = this.personTypes.map(type => type.code);
      return this.programs.filter(
        program => selectedPersonType.includes(program.program.personTypeCode),
      );
    },
    matchTypeQueryParams() {
      const params = { matchEnabled: true };
      if (this.districts.length) {
        params.distictCode = this.districts[0].code;
      }
      return params;
    },
    validForm() {
      return !this.hasErrorFile
        && !this.hasErrorDistrict
        && !this.hasErrorMatchType
        && !this.hasErrorPersonType;
    },
  },
  methods: {
    async loadPrograms() {
      try {
        const res = await axios.get(`matchtypes/${this.matchTypeId}/programs?matchEnabled=true`);
        this.programs = res.data;
      } catch (error) {
        this.$root.$emit('setLoadingError', true);
      }
    },
    checkForm() {
      this.validateAllFields();

      if (this.validForm) {
        this.hideNotification();
        this.match();
      } else {
        this.showNotification('danger',
          ['There were some errors. Please fix the errors highlighted in the fields below.']);
      }
    },
    checkUserDistricts() {
      // if the user is a single-distrit-user then set selectedDistrictType to Specific Districts
      // and assign districtCodes to a list of codes from the store to pass into es-select.
      // if the user is multi-district-user then set selectedDistrictType to Specific Districts.
      // if the user is a state-user then default selectedDistrictType to All Districts.
      if (this.isSingleDistrictUser) { // single-district
        this.selectedDistrictType = 'Specific Districts';
        this.districtCodes = [this.userDistricts[0].code];
        this.districts = this.districtCodes.map(d => ({ code: d }));
      } else if (!this.isStateUser) { // multi-district
        this.selectedDistrictType = 'Specific Districts';
      } else if (this.isStateUser) { // all-district
        this.selectedDistrictType = 'All Districts';
      }
    },
    checkSingleSchoolUser() {
      // if the user is a single-school-user then assign schoolCodes to school:district String
      // from the store to prepare schoolCodePromises computed prop.
      if (this.isSingleSchoolUser) {
        this.schoolCodes = [`${this.userSchools[0].code}:${this.userDistricts[0].code}`];
        this.schools = this.schoolCodes
          .map(code => ({ districtCode: code.split(/[:]+/)[1], code: code.split(/[:]+/)[0] }));
      } else {
        this.schools = [];
      }
    },
    // check initial district and school permissions to set default data selections
    checkUserTypes() {
      this.checkUserDistricts();
      this.checkSingleSchoolUser();
    },
    async match() {
      try {
        this.loadingMatch = true;
        this.$root.$emit('dmMatchOptionsLoading', true); // Match Results loader
        this.$root.$emit('dmMatchOptionsLoadingError', false); // Match Results error message

        // post data
        const postResponse = await axios.post('/directmatch/batches', this.formDataBody);

        // get batch details with batchId from the POST
        const getResponse = await axios.get('directmatch/batches',
          {
            params: { ids: postResponse.data.map(item => item.id) },
            paramsSerializer(params) {
              return qs.stringify(params, { arrayFormat: 'repeat' });
            },
          });
        this.$emit('batchResponse', getResponse.data.data); // emit batch data up to parent level
      } catch (error) {
        this.showNotification('danger', [error.response.data.message]);
        this.$root.$emit('dmMatchOptionsLoadingError', true); // Match Results error message
      } finally {
        this.loadingMatch = false;
        this.$root.$emit('dmMatchOptionsLoading', false); // Match Results loader
      }
    },
    async reset() {
      this.resetting = true;
      this.resetValues();
      this.hasErrorFile = false;
      this.hasErrorDistrict = false;
      this.hasErrorMatchType = false;
      this.hasErrorPersonType = false;
      this.hideNotification();
    },
    resetValues() {
      // clear form values
      this.files = [];
      this.$refs.selDistricts.clear();
      if (this.$refs.selPersonType) {
        this.$refs.selPersonType.clear();
      }
      if (this.enableMatchTypeSelection) {
        this.$refs.selMatchType.clear();
      } else {
        this.matchTypes = [];
      }
    },
    validateAllFields() {
      this.validateDistrict();
      this.validateFile();
      this.validateMatchType();
      this.validatePersonType();
    },
    validateDistrict() {
      if (!this.districts.length) {
        this.hasErrorDistrict = true;
        this.errorMsgDistrict = `${this.getFieldLabel(`PER:${!this.personTypes.length ? this.personType : this.personTypes[0].code}:DIRECTMATCH:DISTRICT_CODE`)} is required.`;
      } else {
        this.hasErrorDistrict = false;
        this.errorMsgDistrict = null;
      }
    },
    validateFile() {
      if (!this.files.length) {
        this.hasErrorFile = true;
      } else {
        this.hasErrorFile = false;
      }
    },
    validateMatchType() {
      if (!this.matchTypes.length) {
        this.hasErrorMatchType = true;
        this.errorMsgMatchType = 'Match Type(s) is required.';
      } else {
        this.hasErrorMatchType = false;
        this.errorMsgMatchType = null;
      }
    },
    validatePersonType() {
      if (!this.personTypes.length && this.dmPersonTypeMatching) {
        this.hasErrorPersonType = true;
        this.errorMsgPersonType = 'Person Type is required.';
      } else {
        this.hasErrorPersonType = false;
        this.errorMsgPersonType = null;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
